<script setup lang="ts">

import { AppBadge } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'
import { LoaderOverlay } from '@shared/ui/loaders'

import { useOrderInvoicePreviewFrame } from '../../model/invoice/order-invoice-preview.hook'

defineOptions({
  name: 'OrderInvoicePreview',
})

const {
  frameUrl,
  stateLabel,
  isUnsaved,
  isLoading,
} = useOrderInvoicePreviewFrame()
</script>

<template>
  <div class="order-invoice-preview">
    <div class="order-invoice-preview__state">
      <AppBadge
        v-if="isUnsaved"
        color="amber"
        :text="stateLabel"
      />
      <AppText
        v-else
        name="body2"
        color="slate-500"
      >
        {{ stateLabel }}
      </AppText>
    </div>
    <div class="order-invoice-preview__frame">
      <iframe
        v-if="frameUrl"
        :src="frameUrl"
        title="Invoice preview"
        class="order-invoice-preview__document"
      />
      <LoaderOverlay
        v-if="isLoading"
        glass
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./OrderInvoicePreview.scss" />
